import { TaskDto, TaskListDto, TaskResourceDtoActivity, TaskResourceDtoType } from '@/api/generated/model';
import { ROUTE_ACTION_PLAN, ROUTE_BUILD_ACTION_PLAN, ROUTE_TEST_DETAILS, ROUTE_TESTING_PLAN } from '@/constants/routes';
import { Divider, Flex, Text } from '@cmpsr/components';
import { Fragment } from 'react';
import DashboardHeaderActionItem from './components/dashboard-header-action-item/dashboard-header-action-item';
import { getRoute } from '@/utils/routing/get-route';
type DashboardHeaderActionsCardProps = {
  tasks?: TaskListDto['data'];
};

export default function DashboardHeaderActionsCard(props: DashboardHeaderActionsCardProps) {
  return props.tasks && props.tasks?.length > 0 ? (
    <Flex
      direction="column"
      gap={4}
      border="1px solid"
      borderColor="medBlue"
      borderRadius="radii-3"
      py={{ base: 5, lg: 7 }}
      px={{ base: 5, lg: 6 }}
      data-testid="risk-analysis-card"
    >
      <Text variant="text-body-meta-medium" color="tan" textTransform="uppercase">
        Your next steps
      </Text>
      {props.tasks?.slice(0, 3).map((task) => (
        <Fragment key={task.resource.id}>
          <Divider borderColor="medBlue" />
          <DashboardHeaderActionItem title={task.title} description={task.description} to={buildTaskURL(task)} />
        </Fragment>
      ))}
    </Flex>
  ) : null;
}

function buildTaskURL(task: TaskDto) {
  switch (task.resource.type) {
    case TaskResourceDtoType['action-plan']:
      switch (task.resource.activity) {
        case TaskResourceDtoActivity['LIST']:
          return getRoute(ROUTE_ACTION_PLAN);
        case TaskResourceDtoActivity['GET']:
          return getRoute(ROUTE_ACTION_PLAN, { idIntervention: task.resource.id });
        case TaskResourceDtoActivity['PATCH']:
          return ROUTE_BUILD_ACTION_PLAN;
        case TaskResourceDtoActivity['POST']:
          return ROUTE_BUILD_ACTION_PLAN;
        default:
          return getRoute(ROUTE_ACTION_PLAN);
      }
    case TaskResourceDtoType['testing-plan']:
      switch (task.resource.activity) {
        case TaskResourceDtoActivity['LIST']:
          return ROUTE_TESTING_PLAN;
        case TaskResourceDtoActivity['GET']:
          return getRoute(ROUTE_TEST_DETAILS, { idTest: task.resource.id });
        default:
          return ROUTE_TESTING_PLAN;
      }
    default:
      return '';
  }
}
